import { defaultTheme } from 'react-admin';

import { getAdminChromeColor } from './adminEnvironment';

// Adjust these values to your preferred sidebar size.
const SIDEBAR_WIDTH = 320;
const SIDEBAR_CLOSED_WIDTH = 64;
const defaultPalette = defaultTheme.palette ?? {};
const sidebarBg = getAdminChromeColor();

export const appTheme = {
    ...defaultTheme,
    palette: {
        ...defaultPalette,
        background: {
            ...(defaultPalette.background ?? {}),
            default: '#f8fafc',
        },
        primary: {
            ...(defaultPalette.primary ?? {}),
            main: sidebarBg,
        },
        secondary: {
            ...(defaultPalette.secondary ?? {}),
            main: '#0891b2',
        },
    },
    sidebar: {
        width: SIDEBAR_WIDTH,
        closedWidth: SIDEBAR_CLOSED_WIDTH,
    },
    components: {
        ...defaultTheme.components,
        RaSidebar: {
            styleOverrides: {
                root: {
                    borderRight: '1px solid rgba(15, 23, 42, 0.08)',
                    boxShadow: '20px 0 45px rgba(15, 23, 42, 0.08)',
                    background: `linear-gradient(180deg, ${sidebarBg} 0%, ${sidebarBg} 100%)`,
                },
                drawerPaper: {
                    borderRight: '1px solid rgba(148, 163, 184, 0.12)',
                    background: `linear-gradient(180deg, ${sidebarBg} 0%, ${sidebarBg} 100%)`,
                    overflowX: 'hidden',
                },
            },
        },
        RaAppBar: {
            styleOverrides: {
                root: {
                    background: sidebarBg,
                    color: '#ffffff',
                },
            },
        },
        RaLayout: {
            styleOverrides: {
                appFrame: {
                    background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)',
                },
                contentWithSidebar: {
                    background: 'transparent',
                },
            },
        },
    },
} as any;
